import * as types from './mutation-types'
import apiVehicle from '../api/vehicle'
import mitelService from '../api/clients/mitelService'
import livevoxService from '../api/clients/livevoxService'
import verintService from '../api/clients/verintService'
import router from '../router'
import StorageManager from '../utils/storageManager'


export const mitelLoginSkip = (({ commit, rootGetters }) => {
    commit(types.MITEL_LOGIN_SKIP)
    if (rootGetters.lastNavigation !== '') {
        router.push(rootGetters.lastNavigation)
    }
    else {
        router.push('/')
    }
});

export const mitelLogin = ({ commit, rootGetters }, creds) => {
    commit(types.MITEL_LOGIN)
    commit(types.LOADING_START, 'Validating credentials...');
    console.log('***LOGIN****')
    // show spinner
    mitelService.login(creds)
        .then(response => {
        if (response.status != 200) {
            const error = {
                title: 'Error',
                message: response.data,
                type: 'error'
            }
            commit(types.NOTIFY_ERRORS, error)
        }
        else {
            StorageManager.saveJWT("MitelServiceJWT", response.data.access_token);
            commit(types.MITEL_LOGIN_SUCCESS)
            if (rootGetters.lastNavigation !== '') {
                router.push(rootGetters.lastNavigation)
            }
            else {
                router.push('/')
            }
        }
        commit(types.LOADED_SUCCESS)
        })  
        .catch(err => {
            console.log(err)
            const error = {
                title: 'Error',
                message: err.message,
                type: 'error'
            }
        commit(types.NOTIFY_ERRORS, error)
        commit(types.LOADED_SUCCESS)
    });
}

export const livevoxLogin = ({ commit, rootGetters }, creds) => {
    commit(types.LIVEVOX_LOGIN)
    commit(types.LOADING_START, 'Validating credentials...');
    console.log('***LOGIN****')
    // show spinner
    livevoxService.login(creds)
    .then(response => {
        if (response.status != 200) {
            if (response.status == 401) {
                const error = {
                    title: 'Error',
                    message: "Invalid credentials",
                    type: 'error'
                }
                commit(types.NOTIFY_ERRORS, error)
            }
            else {
            const error = {
                title: 'Error',
                message: "Unknown error has occurred",
                type: 'error'
            }
                commit(types.NOTIFY_ERRORS, error)
            }
        }
        else {
            StorageManager.saveJWT("LivevoxServiceJWT", response.data);
            commit(types.LIVEVOX_LOGIN_SUCCESS)
            if (rootGetters.lastNavigation !== "" && rootGetters.lastNavigation != "/livevoxlogin") {
                router.push(rootGetters.lastNavigation)
            }
            else {
                router.push('/')
            }
        }
        commit(types.LOADED_SUCCESS)
    })
    .catch(err => {
        console.log(err)
        const error = {
            title: 'Error',
            message: err.message,
            type: 'error'
            }
        commit(types.NOTIFY_ERRORS, error)
        commit(types.LOADED_SUCCESS)
    });
}

export const livevoxLoginSkip = (({ commit, rootGetters }) => {
    commit(types.LIVEVOX_LOGIN_SKIP)
    if (rootGetters.lastNavigation !== "" && rootGetters.lastNavigation != "/livevoxlogin") {
        router.push(rootGetters.lastNavigation)
    }
    else {
        router.push('/')
    }
});

export const verintLogin = ({ commit }) => {
    return verintService.fetchToken()
        .then(() => {
            if (!verintService.token) {
                const error = {
                    title: 'Warning',
                    message: 'Could not connect to Verint. Proceeding without phone system.',
                    type: 'warn'
                }
                commit(types.NOTIFY_ERRORS, error)
            } else {
                commit(types.VERINT_LOGIN_SUCCESS)
            }
        })
        .catch(err => {
            console.log(err)
            const error = {
                title: 'Error',
                message: err.message,
                type: 'error'
            }
            commit(types.NOTIFY_ERRORS, error)
        });
}



// WEBPACK FOOTER //
// ./src/store/actions.js